import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import { Provider } from 'react-redux';
import configureStore from '../../../../redux/configureStore';
import EmailAttachmentPurchaseForm from './EmailAttachmentPurchaseForm';

storiesOf('Docket/Popups/EmailAttachmentPurchaseForm', module).add('View', () => [
  <h3>Step 1</h3>,
  <p>First, we look at price of all PDFs</p>,
  <EmailAttachmentPurchaseForm
    docketParts={{
      parts: [1, 2, 3, 4, 5], // List of input Docket numbers ?
      percentage: 57, // Current Step percent complete
      step: 1, // Current Step number
      status: 'loading', // loading, done
    }}
    buy={action('Buy')}
    showXfaWarning
  />,
  <hr />,
  <h3>Step 1b</h3>,
  <p>We show price for downloads, and user has to click to proceed</p>,
  <Provider store={configureStore()}>
    <EmailAttachmentPurchaseForm
      docketParts={{
        partsToPurchase: 18, // Number of parts that need purchasing, can be greater than number of dockets
        totalParts: 27, // Total number of parts that will be bundled.
        totalCost: 12.4, // Total cost for all purchases
        parts: [1, 2, 3, 4, 5], // List of input Docket numbers ?
        percentage: 99, // Current Step percent complete
        step: 1, // Current Step number
        status: 'done', // loading, done
      }}
      buy={action('Buy')}
    />
  </Provider>,
  <hr />,
  <h3>Step 2</h3>,
  <p>Then, we buy all the dockets</p>,
  <EmailAttachmentPurchaseForm
    docketParts={{
      totalParts: 27, // Total number of parts that will be bundled.
      partsToPurchase: 7, // Number of parts that need purchasing, can be greater than number of dockets
      // totalCost: 12.40,       // Total cost for all purchases
      parts: [1, 2, 3, 4, 5],
      percentage: 17,
      step: 2,
      status: 'loading',
      alreadyPurchased: false, // If there was no purchases to be made for step 2
    }}
    buy={action('Buy')}
  />,
  <hr />,
  <h3>Step 2 - Error</h3>,
  <p>If an error occurred purchasing, the dialog shows the error</p>,
  <EmailAttachmentPurchaseForm
    docketParts={{
      totalParts: 27, // Total number of parts that will be bundled.
      partsToPurchase: 7, // Number of parts that need purchasing, can be greater than number of dockets
      // totalCost: 12.40,       // Total cost for all purchases
      parts: [1, 2, 3, 4, 5],
      percentage: 17,
      step: 2,
      status: 'done',
      errors: ['No PACER Credentials for uid 123.'],
      alreadyPurchased: false, // If there was no purchases to be made for step 2
    }}
    buy={action('Buy')}
  />,
  <hr />,
  <h3>Step 3</h3>,
  <p>Lastly, we could be preparing and sending the message</p>,
  <EmailAttachmentPurchaseForm
    docketParts={{
      totalParts: 27, // Total number of parts that will be bundled.
      partsToPurchase: 7, // Number of parts that need purchasing, can be greater than number of dockets
      parts: [1, 2, 3, 4, 5],
      percentage: 17,
      step: 3,
      status: 'loading',
      purchased: 7, // Number of parts purchased for step 2
      alreadyPurchased: false, // If there was no purchases to be made for step 2
    }}
    buy={action('Buy')}
  />,
]);



// WEBPACK FOOTER //
// ./src/components/case/docket/popups/EmailAttachmentPurchaseForm.stories.jsx